@if (button) {
    <ion-button (click)="onButtonClick()" class="button-unstyled full-width">
        <ng-content *ngTemplateOutlet="item"></ng-content>
        <div class="ion-activatable full-width full-height position-absolute-center">
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </ion-button>
} @else {
    <ng-content *ngTemplateOutlet="item"></ng-content>
}

<ng-template #item>
    @if ((file && file.base64) || userFile) {
        <div
            class="flex align-items-center full-width"
            [ngClass]="{
                'file-item--existing': display === 'existing-upload',
                'file-item--default': display === 'default'
            }">
            <div
                class="file-item--icon margin-right-small"
                [ngClass]="{
                    'icon-style--danger': display === 'existing-upload' && userFile?.verified_status === 'rejected'
                }">
                <lib-svg-icon
                    [color]="
                        display === 'default'
                            ? ' var(--ion-color-dark-orange)'
                            : display === 'existing-upload' &&
                                (isUserFileValid() || userFile?.verified_status === 'pending')
                              ? ' var(--ion-color-dark-orange)'
                              : ' var(--ion-color-red)'
                    "
                    [iconName]="
                        display === 'default'
                            ? 'document-outline'
                            : display === 'existing-upload' &&
                                (isUserFileValid() || userFile?.verified_status === 'pending')
                              ? 'attachment-outline'
                              : 'close-fill'
                    "
                    [size]="display === 'existing-upload' && isUserFileValid() ? 20 : 22" />
            </div>
            <div class="full-width file-item--content">
                <p class="text-dark font-500 ion-no-margin word-break-word">
                    {{ file?.name || userFile?.file_name || getFileNameFromUrl(userFile?.file_url || '') }}
                </p>

                @if (displayFileSize) {
                    <p class="ion-no-margin">
                        {{ formatSize(file?.size || userFile?.file_size) }}

                        @if (userFile?.verified_status === 'pending') {
                            <span class="text-80 text-midsmall">(pending verification)</span>
                        }
                    </p>
                }

                @if (displayFileType && typeLabel()) {
                    <p class="ion-no-margin text-80 text-midsmall">
                        {{ typeLabel() }}
                    </p>
                }

                @if (displayExpiration && (file?.expiration_year || expirationDate || userFile?.expiration_year)) {
                    <p class="ion-no-margin" [ngClass]="{ 'text-danger': userFile?.is_expired }">
                        Expire date:
                        <span class="text-primary">
                            @if (file?.expiration_year) {
                                {{ file?.expiration_year }}
                            } @else if (expirationDate) {
                                {{ expirationDate }}
                            } @else if (userFile?.expiration_year) {
                                {{ userFile?.expiration_year }}
                            }
                        </span>
                    </p>
                }
            </div>
            <div class="z-index-1">
                @if (display === 'existing-upload') {
                    @if (
                        displayEndButtonOnInvalid &&
                        ((userFile && userFile.is_expired) || userFile?.verified_status !== 'approved')
                    ) {
                        <lib-icon-button
                            (onClick)="onEndButtonClick(file)"
                            iconName="plus-thin"
                            color="var(--ion-color-orange)"
                            rippleColor="var(--ion-color-orange)" />
                    }
                } @else if (display === 'default') {
                    <lib-icon-button
                        (onClick)="onRemoveButtonClick(file)"
                        iconName="close"
                        [size]="25"
                        color="var(--ion-color-dark)"
                        rippleColor="var(--ion-color-dark)" />
                }
            </div>
        </div>
    }
</ng-template>

<ion-modal #previewModal class="modal-window">
    <ng-template>
        <div class="ion-padding" [ngClass]="{ 'hidden-visually-important': displayedDeleteConfirmation() }">
            <div class="flex justify-content-end ion-margin-bottom">
                <lib-close-button (onClick)="previewModal.dismiss()" />
            </div>
            <img src="{{ userFile?.file_url }}" />
            @if (userFile?.file_name) {
                <p class="text-dark">{{ userFile?.file_name }}</p>
            }

            <p class="text-dark ion-no-margin ion-margin-top">
                {{
                    this.documentTypeLabels[userFile?.type || '']
                        ? this.documentTypeLabels[userFile?.type || '']
                        : userFile?.type
                }}
            </p>

            <p class="text-dark">
                Expiration date:
                <span class="text-primary font-500">
                    @if (userFile?.expiration_month && userFile?.expiration_month) {
                        {{ userFile?.expiration_year + '-' + userFile?.expiration_month | date: 'MMMM y' }}
                    } @else if (userFile?.expiration_year) {
                        {{ userFile?.expiration_year }}
                    } @else if (userFile?.expiration_month) {
                        {{ defaultExpiryYear + '-' + userFile?.expiration_month | date: 'MMMM y' }}
                    } @else {
                        No expiration date listed
                    }
                </span>
            </p>

            @if (userFile?.is_expired) {
                <p class="text-danger">
                    Your {{ typeLabel() || 'document' | lowercase }} is expired. Please upload a new
                    {{ typeLabel() || 'document' | lowercase }}.
                </p>
            }

            @if (enableDocumentDeletion && userFile && globals.appType === 'pro') {
                <div class="ion-margin-bottom">
                    <lib-button fill="outline" (onClick)="onDelete(userFile.id)">Delete document</lib-button>
                </div>
                <lib-button (onClick)="previewModal.dismiss()">Close</lib-button>
            }
        </div>
    </ng-template>
</ion-modal>
